import { BaseErrorUtility } from "./baseUtility";
import type {
	HttpRequest,
	MappedHttpRequest,
	SendErrorResponse,
} from "./types";

/**
 * Implements universal request mapping, you can map details from your request object manually.
 * See `sendErrorFromEndPoint` method.
 */
export class ErrorUtility extends BaseErrorUtility<HttpRequest> {
	protected mapRequest<TRequest extends HttpRequest = HttpRequest>(
		req: TRequest,
	): MappedHttpRequest {
		return {
			method: req.method ?? null,
			url: req.url ?? null,
			requestBody: req.body ?? null,
			query: req.query ?? null,
			headers: req.headers ?? null,
		};
	}

	async sendErrorFromEndPoint(
		error: unknown,
		request: HttpRequest,
		userContext?: Record<string, unknown> | undefined,
	): Promise<SendErrorResponse> {
		return super.sendErrorFromEndPoint(error, request, userContext);
	}
}
